import React from 'react'
import InputMask from 'react-input-mask'
import Axios from 'axios'

class AutoRefund extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'step': 'form',
      'cinema_id': '0000000026',
      'order': '',
      'card-first': '',
      'card-last': '',
      'submitting': false,
      invalidity_classes: {
        'order': '',
        'card-first': '',
        'card-last': ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.validate = this.validate.bind(this)
    this.submit = this.submit.bind(this)
    this.preSubmit = this.preSubmit.bind(this)
    this.backToForm = this.backToForm.bind(this)
    this.hideAutoRefund = this.hideAutoRefund.bind(this)
    this.autoToManualRefund = this.autoToManualRefund.bind(this)
    this.getSubmittingClass = this.getSubmittingClass.bind(this)
  }

  hideAutoRefund() {
    this.props.hideAutoRefund()
  }

  autoToManualRefund() {
    this.props.autoToManualRefund()
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  validate() {
    let NonEmptyFields = ['order', 'card-first', 'card-last']
    let invalidity_classes = {
      'order': '',
      'card-first': '',
      'card-last': '',
    }
    this.setState({ invalidity_classes: invalidity_classes })
    let valid = true
    // Не должно быть пустых полей
    for (let field of NonEmptyFields) {
      if (this.state[field] === "") {
        invalidity_classes[field] = "general_err"
        valid = false
      }
    }
    // Должно быть достаточно цифр в номере карты
    if (this.state['card-first'].replace(" ", "").replace("_", "").length < 6) {
      console.log(this.state['card-first'].replace(" ", "").replace("_", ""))
      invalidity_classes['card-first'] = "general_err"
      valid = false
    }
    if (this.state['card-last'].replace(" ", "").replace("_", "").length < 4) {
      invalidity_classes['card-last'] = "general_err"
      valid = false
    }
    this.setState({ invalidity_classes: invalidity_classes })
    return valid
  }

  preSubmit() {
    if (this.validate()) {
      this.setState({ 'step': 'confirm' })
    }
  }

  backToForm() {
    this.setState({ 'step': 'form' })
  }

  /**
   * КОСТИЛЬ
   * 15.05.2022
   * На бекенді якісь складнощі. 
   * Проблема: при успішному поверненні квитків -> [res.data.ok = fasle].
   * Тому по флоу відкривається ManualRefund.
   * Тимчасове рішення: перевірка на текстову константу.
   * Видалити цю функцію, коли пофікситься бекенд
   */
  crutch(res) {
    let message = JSON.parse(JSON.parse(res.data.data)).message // message = res.data.data.message
    return 'Возврат заказа успешно выполнен!' === message
  }

  submit() {
    let obj = {
      "cinema_id": this.state["cinema_id"],
      "order": this.state["order"],
      "card-first": this.state["card-first"],
      "card-last": this.state["card-last"],
    }
    let body = new FormData()
    body.set('data', JSON.stringify(obj))
    this.setState({ 'submitting': true })
    Axios({
      method: 'post',
      url: '/auto_refund',
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
      data: body
    }).then(res => {
      if (res.data.ok || this.crutch(res)) {
        this.setState({ 'submitting': false })
        this.setState({ step: "success" })
      } else {
        this.setState({ 'submitting': false })
        this.props.setAutoRefundError()
        this.props.autoToManualRefund()
      }
    }).catch(error => {
      this.setState({ 'submitting': false })
      this.props.setAutoRefundError()
      this.props.autoToManualRefund()
    })
  }

  getSubmittingClass() {
    if (this.state['submitting']) {
      return ' submitting'
    }
    return ''
  }

  render() {
    return (
      <div className="refund__bg">
        {this.state.step === 'form' && <div className="refund__popup auto">
          <div className="refund__close" onClick={this.hideAutoRefund}></div>
          <p className="refund__heading">Автоматичне повернення квитків</p>
          <div className="refund__form">
            <input type="hidden" name="cinema_id" value="0000000026" />
            <label className={'label half small_name ' + this.state.invalidity_classes['order']}>
              <p className="name">Номер замовлення</p>
              <input type="tel" required name="order" onChange={this.handleChange} placeholder="Введіть номер замовлення" value={this.state['order']} />
            </label>
            <label className="label half small_name">
              <p className="name">Номер карти</p>
              <div className="card_inputs">
                <div className="card-first">
                  <InputMask mask="9999 99" name="card-first" onChange={this.handleChange} placeholder="XXXX XX" className={this.state.invalidity_classes['card-first']} value={this.state['card-first']} />
                </div>
                <i></i><i></i><i></i><i></i><i></i><i></i>
                <div className="card-last">
                  <InputMask mask="9999" name="card-last" onChange={this.handleChange} placeholder="XXXX" className={this.state.invalidity_classes['card-last']} value={this.state['card-last']} />
                </div>
              </div>
              <p className="hint">Перші 6 та останні 4 цифри</p>

            </label>
          </div>
          <p className="refund__nodata"><span onClick={this.autoToManualRefund}>Я не маю всіх необхідних даних</span></p>
          <p className="refund__note">
            Автоматичне повернення квитків можливе через 10 хвилин після їх придбання.<br /><br />
            Період повернення коштів - до 31 дня. Період залежить від банку, карткою якого оплачені квитки.
          </p>
          <div className="refund__buttons">
            <div className="refund__confirm" onClick={this.preSubmit}>Підтвердити</div>
            <div className="refund__cancel" onClick={this.hideAutoRefund}>Скасувати</div>
          </div>
        </div>}
        {
          this.state.step === 'confirm' && <div className="refund__confirmation">
            <p className="refund__heading">Перевірте правильність даних</p>
            <div className="refund__data">
              <p><span>Номер замовлення: </span>{this.state.order}</p>
              <p><span>Номер картки: </span>{this.state["card-first"]}** **** {this.state["card-last"]}</p>
            </div>
            <div className="refund__buttons">
              <div className={"refund__confirm" + this.getSubmittingClass()} onClick={this.submit}>{this.state.submitting ? 'Надсилаю...' : 'Підтвердити'}</div>
              <div className="refund__cancel" onClick={this.backToForm}>Виправити</div>
            </div>
          </div>
        }
        {
          this.state.step === 'success' && <div className="refund__result">
            <p className="refund__result__heading">Квитки повернуто!</p>
            <div className="refund__close" onClick={this.hideAutoRefund}></div>
            <img src="/img/il_hand.png" className="refund__result__ill" alt="info" />
            <p className="refund__result__description">
              Заявка прийнята в роботу, Service Desk зробив повернення транзакції. <br /><br />
              Гроші повернуться на картку протягом 31 дня. Будь-ласка чекайте або зверніться в банк, що випустив вашу карту.
            </p>
          </div>
        }
      </div>
    )
  }
}

export default AutoRefund


// WEBPACK FOOTER //
// ./src/components/snippets/AutoRefund.jsx